// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    useEmulators:false,
    firebase: {
        apiKey: "AIzaSyBWOlzNGOIKxx3Da-_qV-tmn8Ej3Z1hteU",
        authDomain: "acceife-fbdb5.firebaseapp.com",
        databaseURL: "https://acceife-fbdb5-default-rtdb.firebaseio.com",
        projectId: "acceife-fbdb5",
        storageBucket: "acceife-fbdb5.appspot.com",
        messagingSenderId: "409067061417",
        appId: "1:409067061417:web:0761c7794887c91bd1a9b8",
        measurementId: "G-8EV8QWGFYL"
    },
  twilio: {
    accountSid: 'AC38125f8e1fee8fc2736126528cb46035',
    authToken: 'your-auth-token-here'
  },

  // Gemini AI API Key
  // Get your API key from: https://makersuite.google.com/app/apikey
  geminiApiKey: 'AQ.Ab8RN6JltGrE0DwDsmyQoLoehmBbXKCa6yzQ-qLEa25gk_pEnw',

  production: true,  // ← false so isDevMode() returns true and testMode collections are used
    mode: 'dev',
    dataEnvironment: 'test',
    testMode: {
        // centres: 'ALCentres',
        centres: 'centres',
        documents: 'Documents',
        units: 'ALUnits2',
        unitsRtdb: 'ALUnits2', // legacy Realtime DB path (migration source only)
        // units: 'ALUnits',
        // child:'UploadALChild',
        child: 'devChild',
        // child: 'ALChild',
        // hospitals: 'dummy/hospitals',
        hospitals: 'devHospitals',
        reminders: 'Reminders',
        prescreening: 'testchild',
        caretakers: 'caretakers',
        counters: 'counters',
        counseling: 'counsellingTest',
        education: 'educationTesting',
        educationGroup: 'educationGroupTesting',
        assessment: 'assessmentsTest',
        employee: 'dummy/employeelist',
        users: 'users',
        volunteers: 'dummy/volunteerlist',
        reqvolunteers: 'volunteer/volunteers',
        donors: 'donors',
        visitors: 'devVisitors',
        fileUploads: 'testfileuploads',
        mealmatesEvents: 'meal-mate/events/',
        mealmatesCounter: 'meal-mate/meal-mate-counter/',
        mealMateDonations: 'MealmateDonations-test',
        receiptCounter: 'receiptcounter/testcounter',
        events: 'events',
      showInventory: true,
      sponsoredChildren: 'testSponsoredChildren',
      unitsponsorship: 'testUnitSponsorships',
      skuCounter: 'testCounters/sku',
      products: 'product',
        purchaseInvoices: 'purchaseInvoices',
        centreInventory: 'centreInventory',
        stockAdjustment: "stockAdjustment",
        inventoryRequests: 'inv-requests',
        transferInventory: 'transferInventory',
        IssueInventory: 'IssueInventory',
        purchaselist: 'purchase-list',
        inventoryLogs:'testInventoryLogs',
        dailyInventoryCount:'testDailyInventoryCount',
        inventoryIssueLog:'dev-InventoryIssueLog',
        customPayments: 'testCustomPayments',
        agreements: 'testAgreements',
        unitTransferLogs: 'testUnitTransferLogs',
        admissionLogHistory: 'testAdmissionLogHistory',
        admissionCycles: 'testAdmissionCycles',
        vehicles: 'vehicles',
        drivers: 'drivers',
        trips: 'trips',
        petrolFilling: 'petrolFilling',
        vehicleServicing: 'vehicleServicing',
        ticketsRaised: 'ticketsRaised',
        productsSubcollection: 'products',
        counsellingFollowUp: 'testCounselingFollowUpAssessment',
        educationFollowUp: 'testEducationFollowUpAssessment',
        counsellingImpactReport: 'testCounselingImpactReport',
        educationImpactReport: 'testEducationImpactReport',
        childCaseStudy: 'testChildCaseStudy',
        reportCard: 'testReportCard',
        counsellingSOP: 'testCounsellingSOP',
        educationSOP: 'testEducationSOP',
        counsellingSessionReviews: 'testCounsellingSessionReviews',
        counsellingCenterLog: 'testCounsellingCenterLog',
        educationCenterLog: 'testEducationCenterLog',
        counsellingPresentationList: 'testCounsellingPresentationList',
        educationPresentationList: 'testEducationPresentationList',
        omShantiRequest: 'testOmShantiRequest',
        highlights: 'testHighlights',
        centreHighlights: 'testCentreHighlights',
        donations: 'testDonations',
        attemptedDonations: 'testAttemptedDonations',
        failedDonations: 'testFailedDonations',
        userPermissions: 'testUserPermissions',
        inquiry8080: 'test-8080-inquiry',
        glossary: 'testGlossary',
        centreRankings: 'testCentreRankings',
        bulkRanking: 'testBulkRanking',
        prefixes: 'testPrefixes',
        minutesOfMeetings: 'testMinutesOfMeetings',
        changeLogs: 'testChangeLogs',
        staffLearningSessions: 'testStaffLearningSessions',
        mealMatePhotoEmail: 'testMealMatePhotoEmail',
        emailFormats: 'testEmailFormats',
        inventoryTaxonomyBackups: 'testInventoryTaxonomyBackups',
        counsellingMonthlySummary: 'testCounsellingMonthlySummary',
        educationMonthlySummary: 'testEducationMonthlySummary',
        admissionLogs: 'testAdmissionLogs',
        inventoryNew: 'testInventoryNew',
        educationObservation: 'testEducationObservation',
        counsellorObservation: 'testCounsellorObservation',
        counsellingWorkUpdates: 'testCounsellingWorkUpdates',
        childFollowUpFeedback: 'testChildFollowUpFeedback',
        advanceMealmateBookings: 'testAdvanceMealmateBookings',
        educationQuestionsList: 'test-education-questions-list',
        counsellingQuestionsList: 'test-counselling-questions-list',
        resourceRepository: 'test-resource-repository',
        counsellingLogs: 'testCounsellingLogs',
        educationLogs: 'testEducationLogs',
        tasks: 'testTasks',
        projects: 'testProjects',
        contact: 'testContact',
        dashboard: 'testDashboard',
        counsellingUploadTest: 'testCounsellingUploadTest',
        notifications: 'testNotifications',
        fileShares: 'testFileShares',

    },
  // testMode: {
  //   centres: 'ALCentres',
  //   units: 'ALUnits',
  //   hospitals: 'Hospitals',
  //   documents: 'ALDocuments',
  //   education: 'educationTest',
  //   educationGroup: 'educationGroupTest',
  //   users: 'users',
  //   child: 'ALChild',
  //   reminders: 'ALReminders',
  //   prescreening: 'ALPrescreening',
  //   caretakers: 'ALCaretakers',
  //   counters: 'ALCounters',
  //   employee: 'ALEmployee',
  //   volunteers: 'ALVolunteers',
  //   reqvolunteers: 'ALReqVolunteers',
  //   assessment: 'Assessments',
  //   counseling: 'Counselling',
  //   donors: 'ALDonors',
  //   fileUploads: 'FileUploads',
  //   mealmatesEvents: 'ALMEAL-MATE/events/',
  //   mealmatesCounter: 'ALMEAL-MATE/meal-mate-counter/',
  //   mealMateDonations: 'MealmateDonations',
  //   receiptCounter: 'receiptcounter/counter',
  //   skuCounter: 'ALCounters/sku',
  //   events: 'events',
  //   sponsoredChildren: 'sponsoredChildren',
  //   unitsponsorship: 'unitSponsorships',
  //   showInventory: true,
  //   products: 'ALProducts',
  //   purchaseInvoices: 'ALPurchases',
  //   centreInventory: 'ALInventory',
  //   stockAdjustment: "ALStockAdjustments",
  //   inventoryRequests: 'ALInventoryRequests',
  //   transferInventory: 'ALTransfers',
  //   IssueInventory: 'ALDirectIssue',
  //   purchaselist: 'ALPurchaseList'
  //
  //
  // },
    productionMode: {
        centres: 'ALCentres',
        units: 'ALUnits',
        unitsRtdb: 'ALUnits', // legacy Realtime DB path (migration source only)
        hospitals: 'ALHospitals',
        documents: 'ALDocuments',
        education: 'educationTest',
        educationGroup: 'educationGroupTest',
        users: 'users',
        child: 'ALChild',
        reminders: 'ALReminders',
        prescreening: 'ALPrescreening',
        caretakers: 'ALCaretakers',
        counters: 'ALCounters',
        employee: 'ALEmployee',
        volunteers: 'ALVolunteers',
        reqvolunteers: 'ALReqVolunteers',
        assessment: 'Assessments',
        counseling: 'Counselling',
        donors: 'ALDonors',
        visitors: 'ALVisitors',
        fileUploads: 'FileUploads',
        mealmatesEvents: 'ALMEAL-MATE/events/',
        mealmatesCounter: 'ALMEAL-MATE/meal-mate-counter/',
        mealMateDonations: 'MealmateDonations',
        receiptCounter: 'receiptcounter/counter',
        skuCounter: 'ALCounters/sku',
        events: 'events',
        sponsoredChildren: 'sponsoredChildren',
        unitsponsorship: 'unitSponsorships',
        showInventory: true,
        // products: 'ALProducts',
        products: 'ALProductsByCentre',
        purchaseInvoices: 'ALPurchases',
        centreInventory: 'ALInventory',
        stockAdjustment: "ALStockAdjustments",
        inventoryRequests: 'ALInventoryRequests',
        transferInventory: 'ALTransfers',
        IssueInventory: 'ALDirectIssue',
        purchaselist: 'ALPurchaseList',
        inventoryLogs:'ALInventoryLogs',
        dailyInventoryCount:'ALDailyInventoryCount',
        inventoryIssueLog:'InventoryIssueLog',
        customPayments: 'ALCustomPayments',
        agreements: 'RentalAgreements',
        unitTransferLogs: 'ALUnitTransferLogs',
        admissionLogHistory: 'AdmissionLogHistory',
        admissionCycles: 'ALAdmissionCycles',
        vehicles: 'ALVehicles',
        drivers: 'ALDrivers',
        trips: 'ALTrips',
        petrolFilling: 'prachipetrolfilling',
        vehicleServicing: 'VehicleServicing',
        ticketsRaised: 'ticket_raised',
        productsSubcollection: 'ALProducts',
        counsellingFollowUp: 'CounselingFollowUpAssessment',
        educationFollowUp: 'EducationFollowUpAssessment',
        counsellingImpactReport: 'CounselingImpactReport',
        educationImpactReport: 'EducationImpactReport',
        childCaseStudy: 'ChildCaseStudy',
        reportCard: 'ReportCard',
        counsellingSOP: 'CounsellingSOP',
        educationSOP: 'EducationSOP',
        counsellingSessionReviews: 'CounsellingSessionReviews',
        counsellingCenterLog: 'ALCounsellingCenterLog',
        educationCenterLog: 'ALEducationCenterLog',
        counsellingPresentationList: 'ALCounsellingPresentationList',
        educationPresentationList: 'ALEducationPresentationList',
        omShantiRequest: 'ALOmShantiRequest',
        highlights: 'ALHighlights',
        centreHighlights: 'ALCentreHighlights',
        donations: 'donations',
        attemptedDonations: 'attemptedDonations',
        failedDonations: 'failedDonations',
        userPermissions: 'user_permissions',
        inquiry8080: '8080-inquiry',
        glossary: 'glossary',
        centreRankings: 'centre-Rankings',
        bulkRanking: 'test-ranking',
        prefixes: 'prefixes',
        minutesOfMeetings: 'minutesOfMeetings',
        changeLogs: 'changeLogs',
        staffLearningSessions: 'staffLearningSessions',
        mealMatePhotoEmail: 'MealMatePhotoEmail',
        emailFormats: 'ALEmailFormats',
        inventoryTaxonomyBackups: 'inventoryTaxonomyBackups',
        counsellingMonthlySummary: 'counsellingMonthlySummary',
        educationMonthlySummary: 'educationMonthlySummary',
        admissionLogs: 'AdmissionLogs',
        inventoryNew: 'ALInventoryNew',
        educationObservation: 'educationObservation',
        counsellorObservation: 'counsellorObservation',
        counsellingWorkUpdates: 'counsellingWorkUpdates',
        childFollowUpFeedback: 'ChildFollowUpFeedback',
        advanceMealmateBookings: 'advanceMealmateBookings',
        educationQuestionsList: 'education-questions-list',
        counsellingQuestionsList: 'counselling-questions-list',
        resourceRepository: 'resource-repository',
        counsellingLogs: 'CounsellingLogs',
        educationLogs: 'EducationLogs',
        tasks: 'tasks',
        projects: 'projects',
        contact: 'contact',
        dashboard: 'dashboard',
        counsellingUploadTest: 'CounsellingUploadTest',
        notifications: 'notifications',
        fileShares: 'FileShares',

    },
    cloudFunctions: {
        getpayments: 'https://us-central1-acceife-fbdb5.cloudfunctions.net/fetchpayments',
        fetchPaymentByDate: 'https://us-central1-acceife-fbdb5.cloudfunctions.net/fetchPaymentsByDateAPI',
        geTestpatemnts: ' https://us-central1-acceife-fbdb5.cloudfunctions.net/geTestpayments',
        fetchpayments: 'https://us-central1-acceife-fbdb5.cloudfunctions.net/fetchpayments',
        fetchRazoryPay: 'https://us-central1-acceife-fbdb5.cloudfunctions.net/fetchRazoryPay',
        fetchRazoryPaycors: 'https://us-central1-acceife-fbdb5.cloudfunctions.net/fetchRazoryPaycors'
    }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
// test accesslige key

//* var test_key_id = "rzp_test_M9aqnxvLMQo6VC";
//* var key_id = "rzp_live_n1im1rcGlUYmyU";
//* var test_key_secret = "hbAlfVs0EdoEZqy9uKz4ggQ5";
//*  test accesslife
//* var key_secret = "nuYSZGm2PvUjbnZ

